/*==============================================================================================
FILE:                 convertTimeZone.ts
AUTHOR:               N/A
CREATED Date:         N/A
LAST MODIFIED:        22/08/2025
DESCRIPTION:          Converts UTC date to target timezone.
=================================================================================================
REVISION HISTORY:
=================================================================================================
S No  Date             Author             User Story/Change Request    Description
=================================================================================================
  1   22-08-2025       Goutham Sundar                                  Prod Issue
================================================================================================*/

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

type TimezoneProps = {
  utcDate: string | Date | null | undefined;
  targetTimezone?: string;
  format?: string;
};

const convertToTimezone = ({
  utcDate,
  targetTimezone = "Asia/Hong_Kong",
  format = "DD MMM YYYY",
}: TimezoneProps): string | null => {
  if (!utcDate) return null; // Strict null and undefined check
  const parsedDate = dayjs(utcDate); // Parse without UTC by default
  if (!parsedDate.isValid()) {
    console.error("Invalid date provided:", utcDate);
    return null; // Safeguard invalid dates
  }
  try {
    return parsedDate.utc().tz(targetTimezone).format(format); // Safe timezone+format
  } catch (error) {
    console.error("Timezone conversion error:", error, utcDate, targetTimezone);
    return null;
  }
};

export default convertToTimezone;
